export default __webpack_public_path__ + "static/media/Jay Vaingankar.80655afe.jpg";